import { Success } from '@components/success/success';
import { RichIconTypes } from '@eika/rich-icon';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';

export const ApplicantParentSuccessPage = () => {
    const { success, backToOverview } = useTranslation();
    const { overview } = useLinks();

    return (
        <Success
            header={success.applicantParentSuccess.header}
            ingress={success.applicantParentSuccess.ingress}
            href={overview.url}
            linkText={backToOverview}
            successRichIcon={RichIconTypes.TOMMEL_OPP}
        />
    );
};
